/**
 * @generated SignedSource<<63dcdf32198042151bd4426ae39cf7a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BalancesPoolFragment$data = {
  readonly bow: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BalanceThumbDualFragment">;
  }>;
  readonly strategies: ReadonlyArray<{
    readonly __typename: "BowAccount";
    readonly id: string;
    readonly pool: {
      readonly config: {
        readonly x?: {
          readonly metadata: {
            readonly symbol: string;
          };
        };
        readonly y?: {
          readonly metadata: {
            readonly symbol: string;
          };
        };
      };
    };
    readonly valueUsd: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"BowPoolXykThumbFragment">;
  } | {
    readonly __typename: "GhostVaultAccount";
    readonly id: string;
    readonly valueUsd: bigint;
    readonly vault: {
      readonly asset: {
        readonly asset: string;
        readonly metadata: {
          readonly symbol: string;
        };
      };
      readonly status: {
        readonly apr: {
          readonly value: bigint | null | undefined;
        };
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"GhostVaultThumbFragment">;
  } | {
    readonly __typename: "IndexAccount";
    readonly allocations: ReadonlyArray<{
      readonly asset: {
        readonly metadata: {
          readonly symbol: string;
        };
      };
    }>;
    readonly id: string;
    readonly index: {
      readonly shareAsset: {
        readonly metadata: {
          readonly symbol: string;
        };
      };
      readonly status: {
        readonly apr: {
          readonly value: bigint | null | undefined;
        };
      };
    };
    readonly sharesValue: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"IndexVaultPortfolioRowFragment" | "IndexVaultThumbFragment">;
  } | {
    readonly __typename: "StakingAccount";
    readonly id: string;
    readonly pendingRevenue: {
      readonly asset: {
        readonly metadata: {
          readonly symbol: string;
        };
      };
    };
    readonly pool: {
      readonly bondAsset: {
        readonly metadata: {
          readonly symbol: string;
        };
      };
      readonly summary: {
        readonly apr: {
          readonly value: bigint | null | undefined;
        };
      };
    };
    readonly valueUsd: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"StakingPoolPortfolioRowFragment" | "StakingPoolThumbFragment">;
  } | {
    readonly __typename: "ThorchainLiquidityProvider";
    readonly asset: {
      readonly asset: string;
      readonly metadata: {
        readonly symbol: string;
      };
    };
    readonly id: string;
    readonly valueUsd: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"ThorchainPoolThumbFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly " $fragmentType": "BalancesPoolFragment";
};
export type BalancesPoolFragment$key = {
  readonly " $data"?: BalancesPoolFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BalancesPoolFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "asset",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUsd",
  "storageKey": null
},
v4 = [
  (v1/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Apr",
    "kind": "LinkedField",
    "name": "apr",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Asset",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BalancesPoolFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BowAccount",
      "kind": "LinkedField",
      "name": "bow",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BalanceThumbDualFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "strategies",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ThorchainPoolThumbFragment"
            }
          ],
          "type": "ThorchainLiquidityProvider",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "BowPool",
              "kind": "LinkedField",
              "name": "pool",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "config",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Asset",
                          "kind": "LinkedField",
                          "name": "x",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Asset",
                          "kind": "LinkedField",
                          "name": "y",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "type": "BowConfigXyk",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BowPoolXykThumbFragment"
            }
          ],
          "type": "BowAccount",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IndexVault",
              "kind": "LinkedField",
              "name": "index",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "shareAsset",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IndexStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharesValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IndexAllocation",
              "kind": "LinkedField",
              "name": "allocations",
              "plural": true,
              "selections": (v6/*: any*/),
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IndexVaultThumbFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IndexVaultPortfolioRowFragment"
            }
          ],
          "type": "IndexAccount",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "StakingPool",
              "kind": "LinkedField",
              "name": "pool",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "bondAsset",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StakingSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Balance",
              "kind": "LinkedField",
              "name": "pendingRevenue",
              "plural": false,
              "selections": (v6/*: any*/),
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StakingPoolThumbFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StakingPoolPortfolioRowFragment"
            }
          ],
          "type": "StakingAccount",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "GhostVault",
              "kind": "LinkedField",
              "name": "vault",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GhostVaultStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GhostVaultThumbFragment"
            }
          ],
          "type": "GhostVaultAccount",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
})();

(node as any).hash = "0393a1c4a89f43421bb10b61919cc547";

export default node;
